const types = {
  CHANGE_GLOBAL_LOADER_STATUS: 'loader/CHANGE_GLOBAL_LOADER_STATUS',
  CHANGE_BUTTON_LOADER_STATUS: 'loader/CHANGE_BUTTON_LOADER_STATUS',
  CHANGE_CONTENT_LOADER_STATUS: 'loader/CHANGE_CONTENT_LOADER_STATUS',
};

export default types;
